import type { Route } from '@angular/router';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';

export const notificationRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/notification-list.component').then(
        ({ NotificationListComponent }) => NotificationListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/notifications-details.component').then(
        ({ NotificationDetailsComponent }) => NotificationDetailsComponent,
      ),
    title: 'PAGES.NOTIFICATIONS.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.NOTIFICATIONS.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/notifications-details.component').then(
        ({ NotificationDetailsComponent }) => NotificationDetailsComponent,
      ),
    title: 'PAGES.NOTIFICATIONS.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.NOTIFICATIONS.SINGULAR'),
      ]),
    ],
  },
];
